<div class="uk-animation-slide-left-small" uk-grid>
  <div class="uk-width-1-1">
    
    <div class="uk-margin-bottom" uk-grid>
      <div class="uk-width-expand@s uk-width-1-1">
        <h2 class="uk-heading-divider uk-text-truncate">Representatives</h2>
      </div>
      <div class="uk-width-auto@s uk-width-1-1 uk-text-right">
        <a routerLink="/manage-representatives" class="uk-button uk-button-secondary uk-align-right uk-width-auto@s">Manage Known Reps</a>
      </div>
    </div>

    <div uk-grid class="uk-animation-slide-left-small uk-margin-remove-top">
      <div class="uk-width-1-1">

        <div class="uk-card uk-overflow-auto" *ngIf="!hideOverview">
          <p>Representatives participate in the <a href="https://docs.nano.org/protocol-design/orv-consensus/" target="_blank" rel="noopener noreferrer">nano consensus protocol</a> on your behalf. You can change them at any time.</p>

          <table class="uk-table uk-table-striped uk-table-small">
            <thead>
              <tr>
                <th scope="col" class="representative-health-column-header hide-on-small-viewports">Status</th>
                <th scope="col" class="uk-width-expand">Representative</th>
                <th scope="col" class="voting-weight-column-header uk-width-1-4 uk-text-right">Voting Weight</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="!loadingRepresentatives">
              <ng-container *ngFor="let rep of representativeOverview">
                <ng-template #representativeHealth>
                  <ng-container [ngSwitch]="true">
                    <div class="representative-health-status health-green" *ngSwitchCase="(rep.statusText == 'trusted')">
                      <div class="health-icon"></div>
                      <div class="label">Good</div>
                    </div>
                    <div class="representative-health-status health-green" *ngSwitchCase="(rep.statusText == 'ok')">
                      <div class="health-icon"></div>
                      <div class="label">Good</div>
                    </div>
                    <div class="representative-health-status health-yellow" *ngSwitchCase="(rep.statusText == 'warn')">
                      <div class="health-icon"></div>
                      <div class="label">Acceptable</div>
                    </div>
                    <div class="representative-health-status health-red" *ngSwitchCase="(rep.statusText == 'alert')">
                      <div class="health-icon"></div>
                      <div class="label">Bad</div>
                    </div>
                    <div class="representative-health-status health-unknown" *ngSwitchDefault>
                      <div class="health-icon"></div>
                      <div class="label">Unknown</div>
                    </div>
                  </ng-container>
                </ng-template>
                <tr class="representative-row">
                  <td class="representative-health-column uk-visible-toggle uk-text-truncate hide-on-small-viewports">
                    <ng-template [ngTemplateOutlet]="representativeHealth"></ng-template>
                  </td>
                  <td class="representative-name-column uk-text-truncate rep-container" (click)="addSelectedAccounts(rep.accounts)">
                    <div class="representative-label-container">
                      <div class="account-label rep">{{ rep.label ? rep.label : 'Unknown Rep' }}</div>
                      <div class="representative-weight-percentage uk-width-auto uk-flex-inline uk-flex-middle">
                        <div class="value uk-text-small text-half-muted" *ngIf="!rep.percent.isZero()">{{ rep.percent.toFixed(2) }}%</div>
                      </div>
                    </div>
                    <div class="representative-address uk-text-small uk-text-truncate">
                      <app-nano-account-id [accountID]="rep.id" middle="auto" class="nano-address-monospace"></app-nano-account-id>
                    </div>
                    <div class="representative-health-compact only-on-small-viewports uk-margin-small-top">
                      <ng-template [ngTemplateOutlet]="representativeHealth"></ng-template>
                    </div>
                  </td>
                  <td class="voting-weight-column uk-width-1-4">
                    <div class="uk-text-small text-half-muted">Total</div>
                    <div class="amounts">
                      <span class="amount-integer">{{ rep.delegatedWeight | rai: 'mnano,true' | amountsplit: 0 }}</span>
                      <span class="amount-fractional">{{ rep.delegatedWeight | rai: 'mnano,true' | amountsplit: 1 }}</span>
                      <span class="currency-name">NANO</span>
                    </div>
                  </td>
                </tr>
                <tr class="delegating-account-row" *ngFor="let delegatingAccount of rep.accounts">
                  <td class="representative-health-column hide-on-small-viewports"></td>
                  <td class="delegating-account-details-column uk-text-truncate account-container" (click)="addSelectedAccounts([ delegatingAccount ])">
                    <div class="delegating-account">
                      <div class="descendant-icon"></div>
                      <div class="descendant-details uk-text-truncate">
                        <div class="descendant-label">
                          <div class="account-label">{{ getAccountLabel(delegatingAccount) }}</div>
                        </div>
                        <div class="descendant-address uk-text-truncate">
                          <app-nano-account-id [accountID]="delegatingAccount.id" middle="auto" class="nano-address-monospace"></app-nano-account-id>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="voting-weight-column uk-width-1-4">
                    <div class="amounts">
                      <span class="amount-integer">{{ delegatingAccount.balance | rai: 'mnano,true' | amountsplit: 0 }}</span>
                      <span class="amount-fractional">{{ delegatingAccount.balance | rai: 'mnano,true' | amountsplit: 1 }}</span>
                      <span class="currency-name">NANO</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
              </ng-container>
              <tr *ngIf="!loadingRepresentatives && ( !representativeOverview || !representativeOverview.length )" class="uk-text-center">
                <td colspan="3" style="text-align: center;" *ngIf="settings.settings.serverAPI">
                  None of your accounts have delegated any voting weight yet, you must receive a transaction to change your representative!
                </td>
                <td colspan="3" style="text-align: center;" *ngIf="!settings.settings.serverAPI">
                  Wallet is in offline mode.
                </td>
              </tr>
              <tr *ngIf="loadingRepresentatives">
                <td colspan="3" style="text-align: center;"><span class="uk-margin-right" uk-spinner></span> Fetching information about your representatives...</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>


      <div class="uk-width-1-1" *ngIf="representativeOverview.length">
        <div class="uk-card uk-card-default">
          <div class="uk-card-body" style="padding-bottom: 0;">

            <p class="uk-text-lead uk-text-center">Change your representatives</p>


            <div class="change-representative-form uk-form-horizontal">

              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-select">Accounts to Change</label>
                <div class="uk-form-controls">
                  <select class="uk-select" [(ngModel)]="changeAccountID" (change)="newAccountID()" id="form-horizontal-select">
                    <option [value]="null">Select Accounts to Change</option>
                    <option [value]="'all'">All Current Accounts</option>
                    <option *ngFor="let account of walletService.wallet.accounts" [value]="account.id">{{account.addressBookName ? account.addressBookName + ' - ' : '#' + account.index + ' - ' }} {{ account.id | squeeze }} ({{ account.balance | rai: 'mnano,true' | amountsplit: 0 }}{{ account.balance | rai: 'mnano,true' | amountsplit: 1 }} NANO)</option>
                  </select>
                  <ul class="uk-list uk-list-striped">
                    <li *ngFor="let account of selectedAccounts">
                      <div uk-grid>
                        <div class="uk-width-5-6 uk-text-truncate">
                          <div *ngIf="(account.id === 'All Current Accounts')">{{ account.id }}</div>
                          <ng-container *ngIf="(account.id !== 'All Current Accounts')">
                            <div class="uk-margin-small-right account-label blue">{{ getAccountLabel(account) }}</div>
                            <div class="uk-text-truncate"><app-nano-account-id [accountID]="account.id" middle="auto" class="nano-address-monospace"></app-nano-account-id></div>
                          </ng-container>
                        </div>
                        <div class="action-remove uk-width-1-6 uk-text-center">
                          <a (click)="removeSelectedAccount(account)" class="uk-text-danger" title="Remove From List" uk-tooltip><span uk-icon="icon: close;"></span></a>
                        </div>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>

              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text2">New Representative</label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <a class="uk-form-icon uk-form-icon-flip" uk-icon="icon: camera" (click)="openQR('rep1','account')" uk-tooltip title="Scan from QR code"></a>
                    <input (blur)="validateRepresentative()" (input)="searchRepresentatives()" (focus)="searchRepresentatives()" [(ngModel)]="toRepresentativeID" class="uk-input" id="form-horizontal-text2" type="text" placeholder="Representative Account" #repInput>

                    <div *ngIf="(representativeResults$ | async).length" [hidden]="!showRepresentatives" class="nlt-dropdown uk-animation-slide-down-small uk-width-1-1 uk-card uk-card-default uk-card-body uk-position-absolute" style="z-index: 15000">
                      <ul class="uk-nav uk-nav-default">
                        <li class="uk-nav-header">Representative List Results</li>
                        <li class="uk-nav-divider"></li>
                        <li *ngFor="let rep of representativeResults$ | async">
                          <a (click)="selectRepresentative(rep.id)">
                            {{ rep.name }}
                            <span *ngIf="rep.trusted" class="uk-text-success" style="margin-left: 4px;"><span uk-icon="icon: star;"></span></span>
                            <span *ngIf="rep.warn" class="uk-text-warning" style="margin-left: 4px;"><span uk-icon="icon: warning;"></span> Avoid</span>
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>

                <div class="uk-form-controls" *ngIf="representativeListMatch">
                  <div class="uk-inline uk-width-1-1 uk-margin-small-top">
                    <span class="account-label rep">{{ representativeListMatch }}</span>
                  </div>
                </div>

                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1 uk-margin-top">
                    <button class="uk-button uk-button-default uk-button-small" *ngIf="showRecommendedReps" (click)="showRecommendedReps = !showRecommendedReps"><span uk-icon="icon: minus; ratio: 0.8" style="margin-right: 5px;"></span> Hide Recommended Representatives</button>
                    <button class="uk-button uk-button-primary uk-button-small" *ngIf="!showRecommendedReps" (click)="showRecommendedReps = !showRecommendedReps"><span uk-icon="icon: plus; ratio: 0.8" style="margin-right: 5px;"></span> View Recommended Representatives</button>
                  </div>
                </div>
              </div>

              <div *ngIf="showRecommendedReps">
                <hr>

                <div class="uk-margin">
                  <!-- <p class="uk-text-lead uk-text-center">Recommended</p> -->
                  <!--<h4>Or, Select a recommended representative</h4>-->
                  <ul class="uk-list uk-list-striped" style="margin-bottom: 0;">
                    <li class="uk-list-header">
                      <div uk-grid>
                        <div class="uk-width-expand">Representatives</div>
                        <!-- <div class="uk-width-1-2">Weight / Uptime / Accounts</div> -->
                        <!--<div class="uk-width-1-5">Uptime / Delegators</div>-->
                      </div>
                    </li>
                  </ul>
                  <ul class="uk-list uk-list-striped" style="margin-top: 0;">
                    <li *ngIf="recommendedRepsLoading" class="uk-text-center">
                      <span uk-icon="load"></span> Loading reps...
                    </li>
                    <li *ngIf="recommendedRepsLoading === null" class="uk-text-center">
                      <span uk-icon="load"></span> Unable to load representatives from My Nano Ninja
                    </li>
                    <li *ngFor="let rep of recommendedRepsPaginated">
                      <div uk-grid >
                        <div class="uk-width-expand" (click)="selectRecommendedRep(rep)" style="cursor: pointer;">
                          <span uk-tooltip title="Select this representative">{{ rep.alias }}</span>
                          <span class="uk-badge" uk-tooltip title="My Nano Ninja Score" style="margin-left: 4px;">{{ rep.weight }}</span>
                        </div>
                        <div class="uk-width-1-2">
                          <!-- <a [href]="'https://mynano.ninja/account/' + rep.account" target="_blank" rel="noopener noreferrer" style="float: right;" uk-tooltip title="View more details on My Nano Ninja" class="uk-link-muted"><span uk-icon="search"></span></a> -->

                          <!-- <span style="display: inline-block; margin-right: 15px;" uk-tooltip title="Percentage of network voting weight delegated" class="uk-text-primary"><span uk-icon="users"></span> {{ rep.percent }}%</span> -->
                          <!-- <span style="display: inline-block; margin-right: 15px; color: #13ab60;" uk-tooltip title="Uptime since creation" class=""><span uk-icon="bolt"></span> {{ rep.uptime }}</span> -->

                        </div>
                      </div>
                    </li>
                  </ul>
                  <a href="https://mynano.ninja" target="_blank" rel="noopener noreferrer" class="view-all-reps-link uk-link-muted" uk-tooltip title="View all verified representatives on MyNanoNinja">View All <span uk-icon="icon: push; ratio: 0.9;"></span></a>
                  <ul class="uk-pagination uk-flex-center uk-flex-middle">
                    <li><a (click)="previousReps()" uk-tooltip title="Previous Page"><span uk-pagination-previous class="uk-icon-button"></span></a></li>
                    <li>Showing {{ (currentRepPage * repsPerPage)+ 1 }} - {{ (currentRepPage * repsPerPage)+ repsPerPage }} of {{ recommendedReps.length }} reps</li>
                    <li><a (click)="nextReps()" uk-tooltip title="Next Page"><span uk-pagination-next class="uk-icon-button"></span></a></li>
                  </ul>
                </div>

              </div>


            </div>
          </div>
          <div class="uk-card-footer">
            <button class="uk-button uk-button-primary uk-width-1-1@s uk-width-auto@m uk-float-right" type="button" (click)="changeRepresentatives()" *ngIf="!changingRepresentatives">Update Representatives</button>
            <button class="uk-button uk-button-secondary uk-width-1-1 uk-disabled nlt-icon-button" type="button" *ngIf="changingRepresentatives"><span class="spinner" uk-spinner="ratio: 0.5;"></span> Updating Representatives</button>
          </div>
      </div>
    </div>
  </div>
</div>
</div>
